module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-rules-selected@2x.png?0.0.53";